export default function frontendAuth() {
    const Authorization = localStorage.getItem("accessToken")
    if (Authorization) {
        return { 'Authorization': Authorization }
    } else {
        return {}
    }
}